export default __webpack_public_path__ + "static/media/img15.11659c4c.png";